import customerApi from '../../components/apis/customerApi';

export function getSchedules(params = {}) {
  return customerApi.get('/api/schedules/core', { params }).then((res) => res.data);
}

export function getScheduleDetailsByIdService(id) {
  return customerApi.get(`/api/schedules/ride-details/${id}`).then((res) => res.data);
}
